import { ClickTracker } from 'bernie-analytics';
import { UitkButtonToggle } from 'uitk-react-button-toggle';
import {
  UitkSecondaryButton,
  UitkPrimaryButton,
  UitkPrimaryFloatingButton,
  UitkTertiaryButton
} from 'uitk-react-button';
import { UitkCheckbox } from 'uitk-react-switch';
import { UitkLink } from 'uitk-react-link';

export const AnchorTracked = ClickTracker('a');
export const ButtonTracked = ClickTracker('button');
export const ButtonToggleTracked = ClickTracker(UitkButtonToggle);
export const CheckboxTracked = ClickTracker(UitkCheckbox);
export const LinkTracked = ClickTracker(UitkLink);
export const PrimaryButtonTracked = ClickTracker(UitkPrimaryButton);
export const SecondaryButtonTracked = ClickTracker(UitkSecondaryButton);
export const PrimaryFloatingButtonTracked = ClickTracker(UitkPrimaryFloatingButton);
export const TertiaryButtonTracked = ClickTracker(UitkTertiaryButton);
